/*
 * Kit Mini — choix client : retirer le cadeau pour utiliser un code promo.
 * Mémorise _gift_declined sur le panier et empêche la ré-addition automatique (EG app).
 */
(function () {
  'use strict';

  var ATTR_KEY = '_gift_declined';
  var KIT_THRESHOLD = 6000;
  var inFlight = false;
  var pending = false;

  function root() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function isGiftLine(item) {
    if (!item.properties) return false;
    return item.properties._Gifted != null || item.properties._free_gift != null;
  }

  function qualifyingTotal(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (!isGiftLine(item)) total += item.final_line_price;
    });
    return total;
  }

  function hasGiftLines(cart) {
    return (cart.items || []).some(isGiftLine);
  }

  function isDeclined(cart) {
    return cart.attributes && cart.attributes[ATTR_KEY] === 'true';
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function getSectionKeys() {
    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.getSectionsToRender === 'function') {
      return cartDrawerItems.getSectionsToRender().map(function (section) {
        return section.section;
      });
    }

    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      return cartItems.getSectionsToRender().map(function (section) {
        return section.section;
      });
    }

    return ['cart-drawer'];
  }

  function refreshCartFromState(state) {
    if (!state || !state.sections) return;

    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.getSectionsToRender === 'function') {
      cartDrawerItems.getSectionsToRender().forEach(function (section) {
        var html = state.sections[section.section];
        if (!html) return;

        document.querySelectorAll('#' + section.id).forEach(function (element) {
          element.innerHTML = cartDrawerItems.getSectionInnerHTML(html, '#' + section.id);
        });
      });
    }

    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach(function (section) {
        var html = state.sections[section.section];
        if (!html) return;

        document.querySelectorAll('#' + section.id).forEach(function (element) {
          element.innerHTML = cartItems.getSectionInnerHTML(html, '#' + section.id);
        });
      });
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.toggle('is-empty', state.item_count === 0);
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-gift-choice' });
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
  }

  function postCart(url, payload) {
    payload.sections = getSectionKeys();
    payload.sections_url = window.location.pathname;

    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json();
    });
  }

  function setDeclined(declined) {
    var attrs = {};
    attrs[ATTR_KEY] = declined ? 'true' : '';
    return postCart('cart/update.js', { attributes: attrs });
  }

  function removeGiftLines(cart) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (isGiftLine(item)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(null);

    var attrs = {};
    attrs[ATTR_KEY] = 'true';
    return postCart('cart/update.js', { attributes: attrs, updates: updates });
  }

  // Un cadeau qui n'est plus à 0 € = la réduction « Trousse » ne s'applique pas
  // (typiquement parce qu'un code promo a été saisi, et l'offre n'est pas cumulable).
  // On retire alors la ligne : jamais de cadeau facturé au client par surprise.
  function hasChargedGift(cart) {
    return (cart.items || []).some(function (item) {
      return isGiftLine(item) && item.final_line_price > 0;
    });
  }

  function run() {
    return getCart().then(function (cart) {
      var qt = qualifyingTotal(cart);
      var declined = isDeclined(cart);
      var gifts = hasGiftLines(cart);

      // Filet de sécurité prioritaire : un cadeau facturé est toujours retiré.
      if (hasChargedGift(cart)) {
        return removeGiftLines(cart).then(refreshCartFromState);
      }

      if (qt < KIT_THRESHOLD && declined) {
        return setDeclined(false).then(refreshCartFromState);
      }

      if (declined && gifts) {
        return removeGiftLines(cart).then(refreshCartFromState);
      }

      return null;
    });
  }

  function reconcile() {
    if (inFlight) {
      pending = true;
      return;
    }
    inFlight = true;
    run()
      .catch(function (e) {
        if (window.console) console.error('[cart-gift-choice]', e);
      })
      .then(function () {
        inFlight = false;
        if (pending) {
          pending = false;
          reconcile();
        }
      });
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('is-loading', loading);
    button.disabled = loading;
  }

  function removeGiftByKey(lineKey, trigger) {
    if (inFlight) return;
    inFlight = true;
    setButtonLoading(trigger, true);

    var updates = {};
    updates[lineKey] = 0;
    var attrs = {};
    attrs[ATTR_KEY] = 'true';

    postCart('cart/update.js', { attributes: attrs, updates: updates })
      .then(function (state) {
        if (state && state.errors) {
          throw new Error(typeof state.errors === 'string' ? state.errors : JSON.stringify(state.errors));
        }
        refreshCartFromState(state);
        window.setTimeout(reconcile, 500);
        window.setTimeout(reconcile, 1500);
      })
      .catch(function (e) {
        if (window.console) console.error('[cart-gift-choice]', e);
      })
      .then(function () {
        inFlight = false;
        setButtonLoading(trigger, false);
      });
  }

  function removeAllGifts(trigger) {
    if (inFlight) return;
    inFlight = true;
    setButtonLoading(trigger, true);

    getCart()
      .then(function (cart) {
        return removeGiftLines(cart);
      })
      .then(function (state) {
        if (!state) return null;
        if (state.errors) {
          throw new Error(typeof state.errors === 'string' ? state.errors : JSON.stringify(state.errors));
        }
        refreshCartFromState(state);
        window.setTimeout(reconcile, 500);
        window.setTimeout(reconcile, 1500);
      })
      .catch(function (e) {
        if (window.console) console.error('[cart-gift-choice]', e);
      })
      .then(function () {
        inFlight = false;
        setButtonLoading(trigger, false);
      });
  }

  function handleGiftRemoval(trigger) {
    var lineKey = trigger && trigger.dataset ? trigger.dataset.lineKey : null;
    if (lineKey) {
      removeGiftByKey(lineKey, trigger);
      return;
    }

    var row = trigger && trigger.closest ? trigger.closest('.cart-item--free-gift') : null;
    if (row && row.dataset.lineKey) {
      removeGiftByKey(row.dataset.lineKey, trigger);
      return;
    }

    removeAllGifts(trigger);
  }

  // Le client revient sur son choix : l'app cadeau réajoutera la ligne au prochain cycle.
  function restoreGift(trigger) {
    if (inFlight) return;
    inFlight = true;
    setButtonLoading(trigger, true);

    setDeclined(false)
      .then(function (state) {
        if (state && state.errors) {
          throw new Error(typeof state.errors === 'string' ? state.errors : JSON.stringify(state.errors));
        }
        refreshCartFromState(state);
        window.setTimeout(reconcile, 500);
        window.setTimeout(reconcile, 1500);
      })
      .catch(function (e) {
        if (window.console) console.error('[cart-gift-choice]', e);
      })
      .then(function () {
        inFlight = false;
        setButtonLoading(trigger, false);
      });
  }

  function hookClicks() {
    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest) return;

        var giftRestore = event.target.closest('.cart-gift-restore');
        if (giftRestore) {
          event.preventDefault();
          event.stopImmediatePropagation();
          restoreGift(giftRestore);
          return;
        }

        var giftRemove = event.target.closest('.cart-gift-remove');
        if (giftRemove) {
          event.preventDefault();
          event.stopImmediatePropagation();
          handleGiftRemoval(giftRemove);
          return;
        }

        var removeBtn = event.target.closest('cart-remove-button');
        if (!removeBtn || !removeBtn.closest('.cart-item--free-gift')) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        handleGiftRemoval(removeBtn);
      },
      true
    );
  }

  function hook() {
    hookClicks();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'cart-gift-choice') return;
        reconcile();
      });
    }
    document.addEventListener('cart:updated', function (e) {
      if (e && e.detail && e.detail.cart && e.detail.cart.attributes) return;
      reconcile();
    });
    document.addEventListener('discount:update', reconcile);
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  } else {
    hook();
  }
})();
